import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './Privacy.css';

const SECTION_IDS = ['hero', 'about', 'products', 'service', 'qna', 'contact'];

function Privacy() {
  return (
    <div>
      <Navbar currentSection={-1} onNavigate={() => {}} sectionIds={SECTION_IDS} />
      <div className="privacy-wrap">
        <div className="container">
          <h1>개인정보 처리방침</h1>

          <p>(주)메디로지스 ('medilogis.net'이하 '메디로지스')은(는) 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.</p>
          <p>메디로지스 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.</p>
          <p>○ 본 방침은 2017년 1월 1일부터 시행됩니다.</p>

          <h2>1. 개인정보의 처리 목적</h2>
          <p>메디로지스는 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.</p>
          <p>가. 홈페이지 회원가입 및 관리<br/>회원제 서비스 제공에 따른 본인 식별·인증 등을 목적으로 개인정보를 처리합니다.</p>
          <p>나. 재화 또는 서비스 제공<br/>서비스 제공, 맞춤 서비스 제공, 요금결제·정산 등을 목적으로 개인정보를 처리합니다.</p>
          <p>다. 마케팅 및 광고에의 활용<br/>서비스의 유효성 확인 등을 목적으로 개인정보를 처리합니다.</p>

          <h2>2. 개인정보 파일 현황</h2>
          <p>1. 개인정보 파일명 : 안드로이드 앱 개인정보 취급 방침</p>
          <ul>
            <li>개인정보 항목 : 이메일, 휴대전화번호, 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보, 결제기록</li>
            <li>수집방법 : 홈페이지, 생성정보 수집 툴을 통한 수집</li>
            <li>보유근거 : 없음</li>
            <li>보유기간 : 지체없이 파기</li>
            <li>관련법령 : 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년, 대금결제 및 재화 등의 공급에 관한 기록 : 5년, 계약 또는 청약철회 등에 관한 기록 : 5년, 표시/광고에 관한 기록 : 6개월</li>
          </ul>

          <h2>3. 개인정보처리 위탁</h2>
          <p>1. 메디로지스는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
          <p>2. 메디로지스는 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
          <p>3. 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>

          <h2>4. 정보주체의 권리, 의무 및 그 행사방법</h2>
          <p>이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.</p>
          <p>① 정보주체는 메디로지스에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
          <ol>
            <li>개인정보 열람요구</li>
            <li>오류 등이 있을 경우 정정 요구</li>
            <li>삭제요구</li>
            <li>처리정지 요구</li>
          </ol>

          <h2>5. 처리하는 개인정보의 항목 작성</h2>
          <p>메디로지스는 다음의 개인정보 항목을 처리하고 있습니다.</p>

          <h2>6. 개인정보의 파기</h2>
          <p>메디로지스는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.</p>
          <p><strong>파기절차</strong><br/>이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다.</p>
          <p><strong>파기기한</strong><br/>이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.</p>
          <p><strong>파기방법</strong><br/>전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</p>

          <h2>7. 개인정보의 안전성 확보 조치</h2>
          <p>메디로지스는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</p>
          <ol>
            <li>정기적인 자체 감사 실시</li>
            <li>개인정보 취급 직원의 최소화 및 교육</li>
            <li>내부관리계획의 수립 및 시행</li>
            <li>해킹 등에 대비한 기술적 대책</li>
            <li>개인정보의 암호화</li>
            <li>접속기록의 보관 및 위변조 방지</li>
            <li>개인정보에 대한 접근 제한</li>
            <li>문서보안을 위한 잠금장치 사용</li>
            <li>비인가자에 대한 출입 통제</li>
          </ol>

          <h2>8. 개인정보 보호책임자</h2>
          <p>메디로지스는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
          <p><strong>개인정보 보호책임자</strong><br/>성명 : 서휘석<br/>연락처 : 031-8042-7660, cafeseo@medilogis.net</p>

          <h2>9. 개인정보 처리방침 변경</h2>
          <p>이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Privacy;
